import { Module } from "vuex";
import state, { SettingsState } from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import RootState from "../rootState";

const onboardingModule: Module<SettingsState, RootState> = {
  actions,
  state,
  getters,
  mutations,
};

export default onboardingModule;
